import { createContext } from "react";
const PageContext = createContext(false);
export {
  PageContext
};
